// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signature-wrapper {
  margin-bottom: 1rem;
  max-width: 500px;
}

.label {
  font-weight: 600;
  color: #555;
}

.required {
  color: red;
}

.signature-canvas {
  width: 100%;
  height: 150px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background: #FAEBD6;
  cursor: crosshair;
  transition: 0.2s;
}

.signature-canvas.locked {
  opacity: 0.5;
  cursor: not-allowed;
}

.error-box {
  margin-top: 6px;
  padding: 4px 8px;
  border-radius: 5px;
  background: #fee;
  border: 1px solid #f88;
  font-size: 12px;
  color: #d00;
  display: flex;
  gap: 6px;
  align-items: center;
}

.toolbar {
  margin-top: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.clear-btn {
  padding: 6px 12px;
  background: #e33;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s;
  border: none;
}
.clear-btn:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.switch {
  position: relative;
  display: inline-block;
  width: 34px;
  height: 18px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  inset: 0;
  background: #ccc;
  border-radius: 18px;
  cursor: pointer;
  transition: 0.2s;
}
.slider::before {
  content: "";
  position: absolute;
  width: 16px;
  height: 16px;
  background: white;
  border-radius: 50%;
  top: 1px;
  left: 1px;
  transition: 0.2s;
}

input:checked + .slider {
  background: #4caf50;
}

input:checked + .slider::before {
  transform: translateX(16px);
}

.status {
  margin-left: 8px;
  font-size: 14px;
}
.status.locked {
  color: #777;
}
.status.unlocked {
  color: #0a0;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
